import Axios from 'axios';
import ApolloClient from 'apollo-boost';

class Client {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
    this.AxiosInstance = Axios.create({
      baseURL: `${this.baseUrl.endpoint}`,
    });
    this.apolloClient = new ApolloClient({
      uri: `${this.baseUrl.endpoint}graphql`,
    });
  }
}

const generateGraphqlMutation = apolloClient => ({
  variables = null,
  mutation,
}) => {
  return apolloClient.mutate({
    variables,
    mutation,
  });
};

const generateGraphqlQuery = apolloClient => ({
  variables,
  query,
  ...props
}) => {
  return apolloClient.query({
    ...props,
    fetchPolicy: 'no-cache',
    variables,
    query,
  });
};

const generateGraphqlCacheQuery = apolloClient => ({
  variables,
  query,
  ...props
}) => {
  return apolloClient.query({
    ...props,
    fetchPolicy: 'cache-first',
    variables,
    query,
  });
};

// export default Client;
export {
  Client as default,
  generateGraphqlMutation,
  generateGraphqlQuery,
  generateGraphqlCacheQuery,
};
